@if (Company && LocalizationInfo) {
  <div class="modal-header">
    <div class="modal-title">
      <h3 class="mb-0">{{ title }}</h3>
      <p class="modal-subtitle mb-0">
        Enter the vendor details below. Any unregistered vendor must register
        with VIVE before being awarded the QuickSource bid.
      </p>
    </div>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    <app-add-edit-proposal-request-vendor
      [ProposalRequestVendorFormArray]="ProposalRequestVendorFormArray"
      [LocalizationInfo]="LocalizationInfo"
      [country]="country"
    ></app-add-edit-proposal-request-vendor>
  </div>

  <div class="modal-footer">
    <div class="action-row w-100 align-items-center">
      <button
        type="button"
        class="btn btn-outline"
        (click)="addNonViveVendor()"
      >
        <i class="bi bi-plus-lg me-1"></i>
        Add another vendor
      </button>
      <span class="ms-auto"></span>
      <button type="button" class="btn btn-ghost" (click)="close()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" (click)="save()">
        Save
      </button>
    </div>
  </div>
}
